import axios from "axios";
import {
  URL,
  getAuthorizationHeader,
  getAuthorizationHeaderUpload,
  idEmpresa,
  username,
} from "../../constans/constants";
import { SET_TRAMITES, SET_LOADING } from "../../constans/action-types";
import Cookies from "universal-cookie";

const cookies = new Cookies();
const defaultPage = 0;
const defaultSize = 5;
export const setTramites = (payload) => ({ type: SET_TRAMITES, payload });

export const getTramites = (
  page = defaultPage,
  size = defaultSize,
  search,
  estado
) => {
  return (dispatch) => {
    var urlRequest = "";
    var idEmpresa = cookies.get("empresa");
    if (
      (search == null || search == "") &&
      (idEmpresa == null || idEmpresa == undefined)
    ) {
      urlRequest =
        URL +
        "tramite/bandeja/" +
        "listar?page=" +
        page +
        "&size=" +
        size + "&estado=" + estado;
    } else if (
      (search != null || search != "") &&
      (idEmpresa == null || idEmpresa == undefined)
    ) {
      urlRequest =
        URL +
        "tramite/bandeja/" +
        "listar?page=" +
        page +
        "&size=" +
        size +
        "&search=" +
        search + "&estado=" + estado;
    } else if ((search == null || search == "") && idEmpresa != null) {
      urlRequest =
        URL +
        "tramite/bandeja/" +
        "listar?page=" +
        page +
        "&size=" +
        size +
        "&idEmpresa=" +
        idEmpresa + "&estado=" + estado;
    } else if (search != null && idEmpresa != null) {
      urlRequest =
        URL +
        "tramite/bandeja/" +
        "listar?page=" +
        page +
        "&size=" +
        size +
        "&search=" +
        search +
        "&idEmpresa=" +
        idEmpresa + "&estado=" + estado;
    }
    return axios.get(urlRequest, getAuthorizationHeader()).then((res) => {
      dispatch(
        setTramites({
          page: res.data.page.pageable.pageNumber,
          totalCount: res.data.page.totalElements,
          tramites: res.data.page.content,
        })
      );
    });
  };
};

export const informacionTramite = async (idTramite) =>{
  const resp = await axios.get(URL + "tramite/" + idTramite + "/datos", getAuthorizationHeader());
  return resp.data;
}

export const obtenerFormatoFirmaSolicitante = async (idTramite, username) => {
  const resp = await axios.get(
    URL + "tramite/getFormatoFirmaSolicitante/" + idTramite + "/" + username,
    getAuthorizationHeader()
  );
  return resp.data;
}

export const eliminarTramite = async (idTramite) =>{
  const resp = await axios.delete(URL + "tramite/eliminar/" + idTramite, getAuthorizationHeader());
  return resp.data;
}

export const firmaTramite = (datosFirma) => {
  const json = {
    keystoreId: datosFirma.keystoreId,
    pin: datosFirma.pin,
    appearance: datosFirma.appearance,
    idTramite: datosFirma.idTramite,
    iscertToken: localStorage.getItem("tokenIscert"),
    psa: localStorage.getItem("codigoClienteFirma"),
    idEmpresa: cookies.get("empresa"),
    username: cookies.get("username")
  };
  return axios
    .post(
      URL + "tramite/firmar",
      json,
      getAuthorizationHeader()
    )
    .then((response) => {
      return response.data;
    });
};

export const getTramitesBandeja = (
  page = defaultPage,
  size = defaultSize,
  search,
  estado,
  firmado = false
) => {
  return (dispatch) => {
    var urlRequest = "";
    var idEmpresa = cookies.get("empresa");
    if (
      (search == null || search == "") &&
      (idEmpresa == null || idEmpresa == undefined)
    ) {
      urlRequest =
        URL +
        "tramite/bandeja/receptor/" +
        "listar?page=" +
        page +
        "&size=" +
        size + "&estado=" + estado + "&firmado=" + firmado;
    } else if (
      (search != null || search != "") &&
      (idEmpresa == null || idEmpresa == undefined)
    ) {
      urlRequest =
        URL +
        "tramite/bandeja/receptor/" +
        "listar?page=" +
        page +
        "&size=" +
        size +
        "&search=" +
        search + "&estado=" + estado + "&firmado=" + firmado;
    } else if ((search == null || search == "") && idEmpresa != null) {
      urlRequest =
        URL +
        "tramite/bandeja/receptor/" +
        "listar?page=" +
        page +
        "&size=" +
        size +
        "&idEmpresa=" +
        idEmpresa + "&estado=" + estado + "&firmado=" + firmado;
    } else if (search != null && idEmpresa != null) {
      urlRequest =
        URL +
        "tramite/bandeja/receptor/" +
        "listar?page=" +
        page +
        "&size=" +
        size +
        "&search=" +
        search +
        "&idEmpresa=" +
        idEmpresa + "&estado=" + estado + "&firmado=" + firmado;
    }
    return axios.get(urlRequest, getAuthorizationHeader()).then((res) => {
      dispatch(
        setTramites({
          page: res.data.page.pageable.pageNumber,
          totalCount: res.data.page.totalElements,
          tramites: res.data.page.content,
        })
      );
    });
  };
};

export const getTramitesBandejaFirmados = (
  page = defaultPage,
  size = defaultSize,
  search,
  firmado = false
) => {
  return (dispatch) => {
    var urlRequest = "";
    var idEmpresa = cookies.get("empresa");
    if (
      (search == null || search == "") &&
      (idEmpresa == null || idEmpresa == undefined)
    ) {
      urlRequest =
        URL +
        "tramite/bandeja/receptor/" +
        "listar/firmados?page=" +
        page +
        "&size=" +
        size +"&firmado=" + firmado;
    } else if (
      (search != null || search != "") &&
      (idEmpresa == null || idEmpresa == undefined)
    ) {
      urlRequest =
        URL +
        "tramite/bandeja/receptor/" +
        "listar/firmados?page=" +
        page +
        "&size=" +
        size +
        "&search=" +
        search + "&firmado=" + firmado;
    } else if ((search == null || search == "") && idEmpresa != null) {
      urlRequest =
        URL +
        "tramite/bandeja/receptor/" +
        "listar/firmados?page=" +
        page +
        "&size=" +
        size +
        "&idEmpresa=" +
        idEmpresa + "&firmado=" + firmado;
    } else if (search != null && idEmpresa != null) {
      urlRequest =
        URL +
        "tramite/bandeja/receptor/" +
        "listar/firmados?page=" +
        page +
        "&size=" +
        size +
        "&search=" +
        search +
        "&idEmpresa=" +
        idEmpresa + "&firmado=" + firmado;
    }
    return axios.get(urlRequest, getAuthorizationHeader()).then((res) => {
      dispatch(
        setTramites({
          page: res.data.page.pageable.pageNumber,
          totalCount: res.data.page.totalElements,
          tramites: res.data.page.content,
        })
      );
    });
  };
};

export const rechazarTramite = (tramiteId, comentario) => {
  const json = {
    id: tramiteId,
    mensaje: comentario
  }
  return axios
    .post(URL + "tramite/rechazar", json, getAuthorizationHeader())
    .then((response) => {
      return response.data;
    });
}

export const reasignarTramite = (tramiteId, nuevoMiembro) => {
  const json = {
    idTramite: tramiteId,
    usuario: username(),
    idEmpresa: idEmpresa(),
    miembroAReasignar: nuevoMiembro
  }
  return axios
    .post(URL + "tramite/reasignar", json, getAuthorizationHeader())
    .then((response) => {
      return response.data;
    });
}

export const subirAdjunto = async (file, idTramite) => {
  const response = await axios.post(
    URL + "tramite/adjunto/" + idTramite,
    file,
    getAuthorizationHeaderUpload()
  );
  return response.data;
}
